export default "__VITE_ASSET__9fb59Pe1__"